import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-theme-five',
  templateUrl: './theme-five.component.html',
  styleUrls: ['./theme-five.component.css']
})
export class ThemeFiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
